import { render } from "./MedalDetailPage.vue?vue&type=template&id=02f82a7f&scoped=true"
import script from "./MedalDetailPage.vue?vue&type=script&lang=js"
export * from "./MedalDetailPage.vue?vue&type=script&lang=js"

import "./MedalDetailPage.vue?vue&type=style&index=0&id=02f82a7f&lang=less&scoped=true"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f82a7f"]])

export default __exports__